import React from "react";
import { motion } from "framer-motion";
import Mouse from "../components/Mouse";
import { pageProjectsData } from "../data/pageProjectsData";

const PageProject16 = () => {
  const pageProject17Data = pageProjectsData.find(
    (project) => project.id === 17
  );
  // Pour le cas où il n'y a pas de données pour l'ID 17
  if (!pageProject17Data) {
    return <div>Pas de données pour l'ID 17.</div>;
  }
  const pageProjectAnim = {
    initial: {
      opacity: 0,
      x: Math.floor(Math.random() * 900 * (Math.random() > 0.4 ? 1 : -1)),
      y: Math.floor(Math.random() * 1500 * (Math.random() > 0.4 ? 1 : -1)),
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
    },
  };

  const closeWindow = () => {
    window.close();
  };
  return (
    <div>
      <Mouse />
      <div className="page-project">
        <div className="title-page-project">
          <div className="icone hover" onClick={closeWindow}>
            <h3>
              {/* Icône sur le site https://www.toptal.com/designers/htmlarrows/symbols/  */}
              <i className="fa-solid fa-xmark"></i>
            </h3>
          </div>

          <motion.div
            initial="initial"
            animate="visible"
            variants={pageProjectAnim}
            transition={{ duration: 1.2 }}
            // className="img-content"
          >
            <div className="aero-container">
              {/* Afficher les données filtrées */}
              <div key={pageProject17Data.id}>
                <h1>{pageProject17Data.title}</h1>
                <img src={pageProject17Data.img1} alt="project-img" />
                <img src={pageProject17Data.img2} alt="project-img" />
                <img src={pageProject17Data.img3} alt="project-img" />
                <img src={pageProject17Data.img4} alt="project-img" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PageProject16;
